const sendMessage = (consultationId, messageRoomId) => {
  window.open(`${window.location.origin}/care_team_messages/${messageRoomId}?consultation_id=${consultationId}`);
  return true;
};

export default sendMessage;
